import { useLayoutEffect } from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useAppState } from './useAppState';

export const useAppEnvironmentProcess = () => {
  const dispatch = useAppDispatcher();

  const {
    environment: { invalidated },
  } = useAppState();

  const { injectPromise } = useAsyncBoundary();

  const { getAppEnvironment } = useServices();

  useLayoutEffect(() => {
    if (invalidated) {
      const promise = getAppEnvironment().then((value) => {
        dispatch({
          name: 'AppEnvironmentProcess__ValueRecieved',
          value,
        });
      });

      injectPromise(promise);
    }
  }, [dispatch, getAppEnvironment, injectPromise, invalidated]);
};
